import { ASSETS } from "@/lib/assets";

const questions = [
  "¿Cómo funciona realmente?",
  "¿Qué nadie te explica?",
  "¿Cuánto cuesta?",
  "¿Qué riesgo tiene?",
  "¿Qué error cometiste?",
  "¿Qué harías diferente?",
  "¿Dónde está el negocio?",
  "¿Cómo afecta esa decisión tu dinero, tu carrera, tu empresa o tu vida?",
];

export default function EldaMedina() {
  return (
    <main data-testid="elda-page" className="bg-mp-black pt-32 md:pt-40">
      {/* Editorial hero */}
      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-20 md:pb-28">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-7">
            <div className="mp-eyebrow mb-6">Elda Medina · Host &amp; Creator</div>
            <h1 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.03em]">
              Una trayectoria <span className="text-mp-orange">sin una sola etiqueta</span>.
            </h1>
            <p className="mt-8 text-white/80 text-lg leading-relaxed max-w-xl">
              Mercadóloga, empresaria, profesional de ventas, estratega, Realtor®️ en Florida,
              productora y comunicadora. Una carrera construida entre México, España y Estados Unidos.
            </p>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden border border-white/10">
              <img src={ASSETS.eldaHost} alt="Elda Medina" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Sections */}
      <EditorialBlock eyebrow="Formación" title={<>México · Madrid · <span className="text-mp-orange">Los Ángeles</span></>}>
        <p>
          Licenciada en Mercadotecnia por el Tecnológico de Monterrey, con estudios en la
          Universidad Pontificia Comillas de Madrid en Marketing Político, Protocolo Político
          y Marketing Internacional. Su inquietud por explorar disciplinas distintas la llevó
          también a Los Ángeles, California, donde estudió actuación bajo la técnica Meisner.
        </p>
        <p>
          El escenario ha formado parte de su vida desde siempre, particularmente a través del
          teatro musical — un lenguaje que, años después, seguiría presente en su forma de
          producir, contar y conducir historias.
        </p>
      </EditorialBlock>

      <EditorialBlock eyebrow="Corporativo" title={<>Negocios · Marketing · <span className="text-mp-orange">Ventas</span></>} dark>
        <p>
          Más de dos décadas desarrollando su carrera alrededor de las ventas, el marketing,
          hospitality, eventos y desarrollo de negocios. Ha trabajado con marcas y compañías
          como Hard Rock, Hilton y Fontainebleau, entre otras.
        </p>
        <p>
          En cada etapa ha desarrollado estrategias comerciales, campañas publicitarias,
          experiencias y proyectos donde entender al consumidor, comunicar una idea y
          convertirla en resultados ha sido fundamental.
        </p>
      </EditorialBlock>

      <EditorialBlock eyebrow="Emprendimiento" title={<>Emprender · Crear · <span className="text-mp-orange">Producir</span></>}>
        <p>
          Su experiencia no se ha limitado al mundo corporativo. Elda también ha sido empresaria y
          emprendedora: ha tenido y operado restaurantes, desarrollado proyectos relacionados con
          teatro y entretenimiento, producido shows y espectáculos musicales, y trabajado como
          coach de actuación.
        </p>
        <p>
          Su trayectoria cruza hospitality, restaurantes, real estate, construcción, producción,
          entretenimiento, marketing, ventas, eventos, emprendimiento y proyectos de inversión.
          Hoy es Realtor®️ en Florida y continúa activa en múltiples proyectos empresariales y creativos.
        </p>
      </EditorialBlock>

      <EditorialBlock eyebrow="Modo Pro" title={<>Frente al <span className="text-mp-orange">micrófono</span></>} dark image={ASSETS.eldaGuests}>
        <p>
          Elda no conduce el podcast desde la posición de quien pretende tener todas las respuestas.
          Lo hace desde algo mucho más poderoso: la curiosidad de quien quiere entender cómo
          funcionan realmente las cosas.
        </p>
        <p>
          Su experiencia multifacética le permite sentarse frente a empresarios, economistas,
          profesionales, inversionistas, creativos y especialistas de mundos completamente
          diferentes, entender el contexto y llevar la conversación al terreno que realmente le
          importa a la audiencia: la vida real.
        </p>
      </EditorialBlock>

      {/* Su forma de preguntar */}
      <section data-testid="elda-questions" className="bg-mp-black py-24 md:py-36 border-t border-white/10">
        <div className="mx-auto max-w-[1200px] px-6 lg:px-12">
          <div className="mp-eyebrow mb-6">Su forma de preguntar</div>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em]">
            Preguntar lo que <span className="text-mp-orange">muchos quisieran</span> preguntar.
          </h2>
          <ul className="mt-14 space-y-6">
            {questions.map((q, i) => (
              <li key={q} className="grid grid-cols-12 gap-4 border-t border-white/10 pt-6">
                <div className="col-span-2 md:col-span-1 font-display text-mp-orange text-sm tracking-[0.24em]">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-10 md:col-span-11 font-display text-white text-xl md:text-3xl leading-[1.15] tracking-[-0.015em]">
                  {q}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Closing */}
      <section className="bg-mp-off py-24 md:py-36 border-y border-white/10">
        <div className="mx-auto max-w-[1200px] px-6 lg:px-12">
          <p className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-6xl leading-[0.95] tracking-[-0.03em] uppercase">
            No necesitas saberlo todo.<br />
            <span className="text-mp-orange">Necesitas saber a quién preguntarle y qué preguntarle.</span>
          </p>
          <div className="mt-12 border-l-2 border-mp-orange pl-6 md:pl-8 max-w-3xl">
            <p className="font-display text-white text-xl md:text-2xl leading-tight">
              En Modo Pro, el experto trae el conocimiento. <span className="text-mp-orange">Elda hace las preguntas</span> que todos queremos hacer.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

function EditorialBlock({ eyebrow, title, children, dark, image }) {
  return (
    <section className={`py-20 md:py-28 border-t border-white/10 ${dark ? "bg-mp-off" : "bg-mp-black"}`}>
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-4">
          <div className="mp-eyebrow mb-4">{eyebrow}</div>
          <h2 className="font-display font-bold text-white text-3xl md:text-4xl lg:text-5xl leading-[0.95] tracking-[-0.02em]">
            {title}
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7 md:col-start-6 space-y-5 text-white/80 leading-relaxed text-base md:text-lg">
          {children}
          {image && (
            <div className="mt-10 aspect-[16/10] overflow-hidden border border-white/10">
              <img src={image} alt="" className="h-full w-full object-cover" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
